import { useLoaderData } from "react-router";
import React from "react";
import Onboarding from "./app";
import WarningPanel from "warning/WarningPanel";
import { useIsLoggedIn } from "common/SessionContext";

// TODO: This is very weird, we should not have this component.
export const OnboardingApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ClientOnboardingLandingFrontModel>();
  const isLoggedIn = useIsLoggedIn();

  if (viewModel.session !== null) {
    return <Onboarding viewModel={viewModel} />
  }

  const button = !isLoggedIn
    ? {
      text: RESX.GeneralLabels.SignIn,
      link: "/account/login"
    }
    : {
      text: RESX.Dashboard.GoToDashboard,
      link: "/dashboard"
    };

  return <WarningPanel
    breadcrumbs={[]}
    pageTitle={RESX.GeneralWarnings.Warning}
    title={RESX.GeneralWarnings.Warning}
    messageHtml={RESX.GeneralLabels.SomethingUnexpectedHappened}
    messageColor="red"
    primaryButton={button}
    displaySignedInAs={"no"}
  />
}